import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { AuthService, HttpApiService } from '@recruitee/http';

import { environment } from '../../../environments/environment';
import {
  AuthorizeConfirmation,
  LogOut,
  LogOutWithRecruitee,
  NavigateToRecruitee,
  SignIn,
  SignInWithRecruitee,
  SignUp,
  ToggleForeignAdmin,
} from './core.actions';
import { AuthConfirmationSuccessPayload, ICoreState } from './core.interfaces';

@State<ICoreState>({
  name: 'core',
  defaults: {
    isForeignAdmin: false,
  },
})
@Injectable()
export class CoreState {
  constructor(private httpApi: HttpApiService, private authService: AuthService) {}

  @Action(NavigateToRecruitee)
  private navigateToRecruitee(): void {
    window.open(environment.webappUrl, '_blank');
  }

  @Action(SignInWithRecruitee)
  private signInWithRecruitee(): void {
    const port = location.port ? `:${location.port}` : '';
    this.authService.redirectToAuth(`${location.protocol}//${location.hostname}${port}/`);
  }

  @Action(SignIn)
  private signIn(_ctx: StateContext<any>, action: SignIn): Observable<any> {
    return this.httpApi.post('/sign_in', null, action.payload).pipe(
      filter(Boolean),
      tap(res => {
        this.authService.saveAccessTokenInCookie(res.accessToken, false);
      }),
    );
  }

  @Action(LogOutWithRecruitee)
  private logOLogOutWithRecruiteeut(): void {
    this.authService.signOut();
  }

  @Action(LogOut)
  private LogOut(): Observable<any> {
    return this.httpApi.get('/sign_out').pipe(
      tap(res => {
        this.authService.clearAuthCookies();
      }),
    );
  }

  @Action(SignUp)
  private signUp(ctx: StateContext<ICoreState>, action: SignUp): Observable<any> {
    return this.httpApi.post('/registration/send_confirmation', null, action.payload);
  }

  @Action(AuthorizeConfirmation)
  private authorizeConfirmation(
    _ctx: StateContext<ICoreState>,
    action: AuthorizeConfirmation,
  ): Observable<any> {
    return this.httpApi.post('/registration/authorize_confirmation', null, action.payload).pipe(
      tap((res: AuthConfirmationSuccessPayload) => {
        this.authService.saveAccessTokenInCookie(res.accessToken, false);
      }),
    );
  }

  @Action(ToggleForeignAdmin)
  private toggleExternalAdmin(ctx: StateContext<ICoreState>, action: ToggleForeignAdmin): void {
    const state = ctx.getState();
    ctx.patchState({ isForeignAdmin: !state.isForeignAdmin });
  }
}
